import classNames from 'classnames';

import { Svg } from '@components/svg/Svg';

import styles from './related-content.module.scss';

interface RelatedContentProps {
	children?: React.ReactNode;
	className?: string;
	heading: string;
	isElsewherePresents?: boolean;
}

export const RelatedContent = ({
	children,
	className,
	heading,
	isElsewherePresents = false,
}: RelatedContentProps) => (
	<section
		className={classNames(className, styles.section, {
			[styles['section--elsewhere-presents']]: isElsewherePresents,
		})}
	>
		<header className={styles.header}>
			<h2
				className={classNames(styles.heading, {
					[styles['heading--elsewhere-presents']]: isElsewherePresents,
				})}
			>
				{isElsewherePresents ? (
					heading.split(' ').map((word) => (
						<span
							className={classNames(styles.heading__word, {
								[styles['heading__word--hide-mobile']]: ![
									'elsewhere',
									'presents',
								].includes(word.toLowerCase()),
							})}
							key={word}
						>
							{`${word} `}
						</span>
					))
				) : (
					<span>{heading}</span>
				)}
			</h2>
			<Svg className={styles.arrow} id="hand-drawn-arrow-2" />
		</header>
		<div className={styles.content}>{children}</div>
	</section>
);
